import type { Ref } from 'vue'
import type { RouteLocationNormalizedLoaded } from 'vue-router'
import { QueryParams } from '@/const/ShipmentsListQueryFilters'
import { DELIVERED, RETURNED } from '@/const/TrackingEventStatuses'
import { appendToParams } from '@/services/Url'

type Input = {
  route: RouteLocationNormalizedLoaded
  serverOptions: Ref
}

export const makeRequestParams = ({ route, serverOptions }: Input) => {
  const params = new URLSearchParams({
    limit: String(serverOptions.value.rowsPerPage || 50),
    page: String(serverOptions.value.page || 1),
    ascending: '1',
    orderBy: 'last_tracking_event_time',
    [QueryParams.PACKAGES_DIVERTED_TO_SERVICE_POINT]: 'true',
    [QueryParams.EXCLUDE_FORWARDING_IGNORED]: 'true',
  })

  const excludedStatuses: string[] = [DELIVERED, RETURNED]

  const appender = appendToParams(params, QueryParams.LAST_TRACKING_STATUS_EXCLUDE)
  excludedStatuses.forEach(appender)

  if (route?.query.carriers) {
    const appender = appendToParams(params, QueryParams.CARRIER_HANDLE)
    String(route.query.carriers).split(',').forEach(appender)
  }

  if (route?.query.shipmentNumber) {
    const appender = appendToParams(params, QueryParams.SHIPMENT_NUMBER)
    String(route.query.shipmentNumber).split(',').forEach(appender)
  }

  if (route?.query.withServicePointCollectingProblem) {
    params.append(QueryParams.WITH_SERVICE_POINT_COLLECTING_PROBLEM, 'true')
  }

  if (route?.query.withRecipientNotificationProblem) {
    params.append(QueryParams.WITH_RECIPIENT_NOTIFICATION_PROBLEM, 'true')
  }

  return params
}
